module.exports = __webpack_public_path__ + "./docs/img/icon-swift.6133e2838ad6b012bc2699ce22a96be6.svg";